import { render, staticRenderFns } from "./ChartThumb.vue?vue&type=template&id=627c9be0&"
import script from "./ChartThumb.vue?vue&type=script&lang=js&"
export * from "./ChartThumb.vue?vue&type=script&lang=js&"
import style0 from "./ChartThumb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports